import jschardet from 'jschardet';

function arrayBufferToString(buffer: ArrayBuffer, encoding = 'utf-8'): string {
  const uint8Array = new Uint8Array(buffer);
  const decoder = new TextDecoder(encoding, { fatal: false });
  return decoder.decode(uint8Array);
}

function containsReplacementChars(text: string): boolean {
  // Verificar se a string contém caracteres de substituição como �, indicativos de erro de codificação
  return text.includes('�');
}

export default function toUTF8(file: File): Promise<string> {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();

    reader.onload = function(event: ProgressEvent<FileReader>) {
      if (event.target && event.target.result) {
        const textArrayBuffer = event.target.result as ArrayBuffer;

        // Tentar decodificar primeiro como UTF-8
        const utf8Text = arrayBufferToString(textArrayBuffer, 'utf-8');

        // Se não houver caracteres de substituição, consideramos UTF-8 correto
        if (!containsReplacementChars(utf8Text)) {
          resolve(utf8Text);
        } else {
          // Detectar a codificação correta, pois UTF-8 falhou
          const detected = jschardet.detect(arrayBufferToString(textArrayBuffer, 'utf-8'));
          let encoding = detected.encoding ? detected.encoding.toLowerCase() : 'iso-8859-1';

          // Se a detecção indicar windows-1251, ajustar para essa codificação
          if (encoding !== 'utf-8') {
            encoding = encoding === 'windows-1251' ? 'windows-1251' : 'iso-8859-1';
          }

          try {
            const decodedText = arrayBufferToString(textArrayBuffer, encoding);
            resolve(decodedText);
          } catch (error) {
            reject(new Error('Falha ao decodificar o arquivo com a codificação detectada.'));
          }
        }
      } else {
        reject(new Error('Erro ao ler o arquivo.'));
      }
    };

    reader.onerror = function() {
      reject(new Error('Erro ao carregar o arquivo.'));
    };

    reader.readAsArrayBuffer(file);
  });
}
